import * as Yup from 'yup';
import { DateApi } from '../../../../../../../services/Date/Date';

export default Yup.object().shape({
    status: Yup.number()
        .min(1, "invalid Value")
        .max(3, "invalid Value")
        .required('Required'),
});